const { server_ip }= require('../config');

export async function insertNewSchool(token,name,){
    try {
        const response= await fetch(`${server_ip}/api2/pschools`,{
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify({
                name
            }),
        })
        return await response.json();
    } catch (error) {
        alert(JSON.stringify(error));
    }
}

export async function fetchSchools(token,filter,options){
    try {
        const response= await fetch(`${server_ip}/api2/pschools/fetch`,{
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify({
                filter,options
            }),
        })
        return await response.json();
    } catch (error) {
        alert(JSON.stringify(error));
    }
}
export async function fetchSchoolsWithMissionsCount(token,filter,options,missionId){
    try {
        const response= await fetch(`${server_ip}/api2/pschools/fetchWithMissionsCount`,{
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify({
                filter,options,missionId
            }),
        })
        return await response.json();
    } catch (error) {
        alert(JSON.stringify(error));
    }
}
export async function fetchSchoolsWithUsersCount(token,filter,options,missionId){
    try {
        const response= await fetch(`${server_ip}/api2/pschools/fetchWithUsersCount`,{
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify({
                filter,options,missionId
            }),
        })
        return await response.json();
    } catch (error) {
        alert(JSON.stringify(error));
    }
}

export async function fetchSchoolById(token,id,){
    try {
        const response= await fetch(`${server_ip}/api2/pschools/${id}`,{
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`
            }
        })
        return await response.json();
    } catch (error) {
        alert(JSON.stringify(error));
    }
}
export async function updateSchoolById(token,id,data){
    try {
        const response= await fetch(`${server_ip}/api2/pschools/${id}`,{
            method: 'PUT',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify(data),
        })
        return await response.json();
    } catch (error) {
        alert(JSON.stringify(error));
    }
}


//teachert api
export async function teacherUpdateSchoolById(token,data){
    try {
        const response= await fetch(`${server_ip}/api2/pschools/teacher/update`,{
            method: 'PUT',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify(data),
        })
        return await response.json();
    } catch (error) {
        alert(JSON.stringify(error));
    }
}

export async function teacherFetchSchoolInfo(token){
    try {
        const response= await fetch(`${server_ip}/api2/pschools/teacher/info`,{
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`
            }
        })
        return await response.json();
    } catch (error) {
        alert(JSON.stringify(error));
    }
}